/* App.svelte generated by Svelte v3.32.1 */
import {
	SvelteComponent,
	add_flush_callback,
	add_render_callback,
	append,
	attr,
	bind,
	binding_callbacks,
	check_outros,
	create_bidirectional_transition,
	create_component,
	destroy_component,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	listen,
	mount_component,
	run_all,
	safe_not_equal,
	set_data,
	space,
	text,
	transition_in,
	transition_out
} from "svelte/internal";

import { fade } from "svelte/transition";
import LooomCanvas from "./components/LooomCanvas.svelte";
import Color from "canvas-sketch-util/color";
import Random from "canvas-sketch-util/random";
import dragDrop from "drag-drop";
import splashSVG from "./splash.svg.js";
import Settings from "./components/Settings.svelte";
import Button from "./components/Button.svelte";
import Progress from "./components/Progress.svelte";

import {
	isFrameSequenceSupported,
	isWebCodecsSupported,
	isWebMSupported
} from "./components/record";

import { onMount } from "svelte";

function create_if_block_1(ctx) {
	let progress_1;
	let t;
	let if_block_anchor;
	let current;

	progress_1 = new Progress({
			props: {
				progress: /*progress*/ ctx[4],
				color: /*foreground*/ ctx[7]
			}
		});

	let if_block = /*totalPasses*/ ctx[6] > 1 && create_if_block_2(ctx);

	return {
		c() {
			create_component(progress_1.$$.fragment);
			t = space();
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			mount_component(progress_1, target, anchor);
			insert(target, t, anchor);
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const progress_1_changes = {};
			if (dirty[0] & /*progress*/ 16) progress_1_changes.progress = /*progress*/ ctx[4];
			if (dirty[0] & /*foreground*/ 128) progress_1_changes.color = /*foreground*/ ctx[7];
			progress_1.$set(progress_1_changes);

			if (/*totalPasses*/ ctx[6] > 1) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_2(ctx);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		i(local) {
			if (current) return;
			transition_in(progress_1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(progress_1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(progress_1, detaching);
			if (detaching) detach(t);
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (191:8) {#if totalPasses > 1}
function create_if_block_2(ctx) {
	let div;
	let t0_value = /*pass*/ ctx[5] + 1 + "";
	let t0;
	let t1;
	let t2;

	return {
		c() {
			div = element("div");
			t0 = text(t0_value);
			t1 = text(" / ");
			t2 = text(/*totalPasses*/ ctx[6]);
			attr(div, "class", "pass svelte-gfhnbb");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);
			append(div, t2);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*pass*/ 32 && t0_value !== (t0_value = /*pass*/ ctx[5] + 1 + "")) set_data(t0, t0_value);
			if (dirty[0] & /*totalPasses*/ 64) set_data(t2, /*totalPasses*/ ctx[6]);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (217:2) {#if showSettings}
function create_if_block(ctx) {
	let div1;
	let div0;
	let settings_1;
	let updating_duration;
	let updating_fps;
	let updating_recenter;
	let updating_format;
	let updating_transparentBackground;
	let updating_quantizeWithAlpha;
	let updating_qualityPreset;
	let updating_resamplePaths;
	let updating_sizing;
	let updating_width;
	let updating_height;
	let div1_transition;
	let current;
	let mounted;
	let dispose;

	function settings_1_duration_binding(value) {
		/*settings_1_duration_binding*/ ctx[25].call(null, value);
	}

	function settings_1_fps_binding(value) {
		/*settings_1_fps_binding*/ ctx[26].call(null, value);
	}

	function settings_1_recenter_binding(value) {
		/*settings_1_recenter_binding*/ ctx[27].call(null, value);
	}

	function settings_1_format_binding(value) {
		/*settings_1_format_binding*/ ctx[28].call(null, value);
	}

	function settings_1_transparentBackground_binding(value) {
		/*settings_1_transparentBackground_binding*/ ctx[29].call(null, value);
	}

	function settings_1_quantizeWithAlpha_binding(value) {
		/*settings_1_quantizeWithAlpha_binding*/ ctx[30].call(null, value);
	}

	function settings_1_qualityPreset_binding(value) {
		/*settings_1_qualityPreset_binding*/ ctx[31].call(null, value);
	}

	function settings_1_resamplePaths_binding(value) {
		/*settings_1_resamplePaths_binding*/ ctx[32].call(null, value);
	}

	function settings_1_sizing_binding(value) {
		/*settings_1_sizing_binding*/ ctx[33].call(null, value);
	}

	function settings_1_width_binding(value) {
		/*settings_1_width_binding*/ ctx[34].call(null, value);
	}

	function settings_1_height_binding(value) {
		/*settings_1_height_binding*/ ctx[35].call(null, value);
	}

	let settings_1_props = {
		formats: /*formats*/ ctx[11],
		showFormatInfo: !/*hasAllFormats*/ ctx[12]
	};

	if (/*settings*/ ctx[1].duration !== void 0) {
		settings_1_props.duration = /*settings*/ ctx[1].duration;
	}

	if (/*settings*/ ctx[1].fps !== void 0) {
		settings_1_props.fps = /*settings*/ ctx[1].fps;
	}

	if (/*settings*/ ctx[1].recenter !== void 0) {
		settings_1_props.recenter = /*settings*/ ctx[1].recenter;
	}

	if (/*settings*/ ctx[1].format !== void 0) {
		settings_1_props.format = /*settings*/ ctx[1].format;
	}

	if (/*settings*/ ctx[1].transparentBackground !== void 0) {
		settings_1_props.transparentBackground = /*settings*/ ctx[1].transparentBackground;
	}

	if (/*settings*/ ctx[1].quantizeWithAlpha !== void 0) {
		settings_1_props.quantizeWithAlpha = /*settings*/ ctx[1].quantizeWithAlpha;
	}

	if (/*settings*/ ctx[1].qualityPreset !== void 0) {
		settings_1_props.qualityPreset = /*settings*/ ctx[1].qualityPreset;
	}

	if (/*settings*/ ctx[1].resamplePaths !== void 0) {
		settings_1_props.resamplePaths = /*settings*/ ctx[1].resamplePaths;
	}

	if (/*settings*/ ctx[1].sizing !== void 0) {
		settings_1_props.sizing = /*settings*/ ctx[1].sizing;
	}

	if (/*settings*/ ctx[1].width !== void 0) {
		settings_1_props.width = /*settings*/ ctx[1].width;
	}

	if (/*settings*/ ctx[1].height !== void 0) {
		settings_1_props.height = /*settings*/ ctx[1].height;
	}

	settings_1 = new Settings({ props: settings_1_props });
	binding_callbacks.push(() => bind(settings_1, "duration", settings_1_duration_binding));
	binding_callbacks.push(() => bind(settings_1, "fps", settings_1_fps_binding));
	binding_callbacks.push(() => bind(settings_1, "recenter", settings_1_recenter_binding));
	binding_callbacks.push(() => bind(settings_1, "format", settings_1_format_binding));
	binding_callbacks.push(() => bind(settings_1, "transparentBackground", settings_1_transparentBackground_binding));
	binding_callbacks.push(() => bind(settings_1, "quantizeWithAlpha", settings_1_quantizeWithAlpha_binding));
	binding_callbacks.push(() => bind(settings_1, "qualityPreset", settings_1_qualityPreset_binding));
	binding_callbacks.push(() => bind(settings_1, "resamplePaths", settings_1_resamplePaths_binding));
	binding_callbacks.push(() => bind(settings_1, "sizing", settings_1_sizing_binding));
	binding_callbacks.push(() => bind(settings_1, "width", settings_1_width_binding));
	binding_callbacks.push(() => bind(settings_1, "height", settings_1_height_binding));
	settings_1.$on("download", /*downloadJSON*/ ctx[13]);

	return {
		c() {
			div1 = element("div");
			div0 = element("div");
			create_component(settings_1.$$.fragment);
			attr(div0, "class", "settings-popup svelte-gfhnbb");
			attr(div1, "class", "settings-modal svelte-gfhnbb");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, div0);
			mount_component(settings_1, div0, null);
			current = true;

			if (!mounted) {
				dispose = [
					listen(div0, "click", click_handler),
					listen(div1, "click", /*click_handler_1*/ ctx[36])
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			const settings_1_changes = {};

			if (!updating_duration && dirty[0] & /*settings*/ 2) {
				updating_duration = true;
				settings_1_changes.duration = /*settings*/ ctx[1].duration;
				add_flush_callback(() => updating_duration = false);
			}

			if (!updating_fps && dirty[0] & /*settings*/ 2) {
				updating_fps = true;
				settings_1_changes.fps = /*settings*/ ctx[1].fps;
				add_flush_callback(() => updating_fps = false);
			}

			if (!updating_recenter && dirty[0] & /*settings*/ 2) {
				updating_recenter = true;
				settings_1_changes.recenter = /*settings*/ ctx[1].recenter;
				add_flush_callback(() => updating_recenter = false);
			}

			if (!updating_format && dirty[0] & /*settings*/ 2) {
				updating_format = true;
				settings_1_changes.format = /*settings*/ ctx[1].format;
				add_flush_callback(() => updating_format = false);
			}

			if (!updating_transparentBackground && dirty[0] & /*settings*/ 2) {
				updating_transparentBackground = true;
				settings_1_changes.transparentBackground = /*settings*/ ctx[1].transparentBackground;
				add_flush_callback(() => updating_transparentBackground = false);
			}

			if (!updating_quantizeWithAlpha && dirty[0] & /*settings*/ 2) {
				updating_quantizeWithAlpha = true;
				settings_1_changes.quantizeWithAlpha = /*settings*/ ctx[1].quantizeWithAlpha;
				add_flush_callback(() => updating_quantizeWithAlpha = false);
			}

			if (!updating_qualityPreset && dirty[0] & /*settings*/ 2) {
				updating_qualityPreset = true;
				settings_1_changes.qualityPreset = /*settings*/ ctx[1].qualityPreset;
				add_flush_callback(() => updating_qualityPreset = false);
			}

			if (!updating_resamplePaths && dirty[0] & /*settings*/ 2) {
				updating_resamplePaths = true;
				settings_1_changes.resamplePaths = /*settings*/ ctx[1].resamplePaths;
				add_flush_callback(() => updating_resamplePaths = false);
			}

			if (!updating_sizing && dirty[0] & /*settings*/ 2) {
				updating_sizing = true;
				settings_1_changes.sizing = /*settings*/ ctx[1].sizing;
				add_flush_callback(() => updating_sizing = false);
			}

			if (!updating_width && dirty[0] & /*settings*/ 2) {
				updating_width = true;
				settings_1_changes.width = /*settings*/ ctx[1].width;
				add_flush_callback(() => updating_width = false);
			}

			if (!updating_height && dirty[0] & /*settings*/ 2) {
				updating_height = true;
				settings_1_changes.height = /*settings*/ ctx[1].height;
				add_flush_callback(() => updating_height = false);
			}

			settings_1.$set(settings_1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(settings_1.$$.fragment, local);

			add_render_callback(() => {
				if (!div1_transition) div1_transition = create_bidirectional_transition(div1, fade, { duration: 150 }, true);
				div1_transition.run(1);
			});

			current = true;
		},
		o(local) {
			transition_out(settings_1.$$.fragment, local);
			if (!div1_transition) div1_transition = create_bidirectional_transition(div1, fade, { duration: 150 }, false);
			div1_transition.run(0);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div1);
			destroy_component(settings_1);
			if (detaching && div1_transition) div1_transition.end();
			mounted = false;
			run_all(dispose);
		}
	};
}

function create_fragment(ctx) {
	let main;
	let div0;
	let looomcanvas;
	let updating_running;
	let updating_recording;
	let t0;
	let div3;
	let nav;
	let button0;
	let t1;
	let button1;
	let updating_value;
	let t2;
	let button2;
	let updating_value_1;
	let t3;
	let button3;
	let updating_value_2;
	let t4;
	let t5;
	let div2;
	let t10;
	let current;

	function looomcanvas_running_binding(value) {
		/*looomcanvas_running_binding*/ ctx[17].call(null, value);
	}

	function looomcanvas_recording_binding(value) {
		/*looomcanvas_recording_binding*/ ctx[18].call(null, value);
	}

	let looomcanvas_props = {
		resamplePaths: /*settings*/ ctx[1].resamplePaths,
		recenter: /*settings*/ ctx[1].recenter,
		transparentBackground: /*settings*/ ctx[1].transparentBackground && !/*ignoreTransparency*/ ctx[10].includes(/*settings*/ ctx[1].format),
		quantizeWithAlpha: /*settings*/ ctx[1].quantizeWithAlpha,
		fps: /*settings*/ ctx[1].fps,
		duration: /*settings*/ ctx[1].duration,
		qualityPreset: /*settings*/ ctx[1].qualityPreset,
		format: /*settings*/ ctx[1].format,
		sizing: /*settings*/ ctx[1].sizing,
		customWidth: /*settings*/ ctx[1].width,
		customHeight: /*settings*/ ctx[1].height,
		data: /*svg*/ ctx[8]
	};

	if (/*running*/ ctx[2] !== void 0) {
		looomcanvas_props.running = /*running*/ ctx[2];
	}

	if (/*recording*/ ctx[0] !== void 0) {
		looomcanvas_props.recording = /*recording*/ ctx[0];
	}

	looomcanvas = new LooomCanvas({ props: looomcanvas_props });
	/*looomcanvas_binding*/ ctx[16](looomcanvas);
	binding_callbacks.push(() => bind(looomcanvas, "running", looomcanvas_running_binding));
	binding_callbacks.push(() => bind(looomcanvas, "recording", looomcanvas_recording_binding));
	looomcanvas.$on("recordProgress", /*recordProgress_handler*/ ctx[19]);
	looomcanvas.$on("load", /*load_handler*/ ctx[20]);

	button0 = new Button({
			props: {
				alt: "Upload SVG File",
				input: true,
				color: /*foreground*/ ctx[7],
				svg: "file-upload"
			}
		});

	button0.$on("file", /*file_handler*/ ctx[21]);

	function button1_value_binding(value) {
		/*button1_value_binding*/ ctx[22].call(null, value);
	}

	let button1_props = {
		toggleable: true,
		alt: "Settings",
		color: /*foreground*/ ctx[7],
		enabled: !/*recording*/ ctx[0],
		svg: /*showSettings*/ ctx[3] ? "settings-open" : "settings"
	};

	if (/*showSettings*/ ctx[3] !== void 0) {
		button1_props.value = /*showSettings*/ ctx[3];
	}

	button1 = new Button({ props: button1_props });
	binding_callbacks.push(() => bind(button1, "value", button1_value_binding));

	function button2_value_binding(value) {
		/*button2_value_binding*/ ctx[23].call(null, value);
	}

	let button2_props = {
		alt: "Toggle Play",
		toggleable: true,
		color: /*foreground*/ ctx[7],
		enabled: !/*recording*/ ctx[0],
		svg: /*running*/ ctx[2] ? "player-pause" : "player-play"
	};

	if (/*running*/ ctx[2] !== void 0) {
		button2_props.value = /*running*/ ctx[2];
	}

	button2 = new Button({ props: button2_props });
	binding_callbacks.push(() => bind(button2, "value", button2_value_binding));

	function button3_value_binding(value) {
		/*button3_value_binding*/ ctx[24].call(null, value);
	}

	let button3_props = {
		alt: "Toggle Record",
		toggleable: true,
		color: /*foreground*/ ctx[7],
		svg: /*recording*/ ctx[0]
		? "player-recording"
		: "player-record"
	};

	if (/*recording*/ ctx[0] !== void 0) {
		button3_props.value = /*recording*/ ctx[0];
	}

	button3 = new Button({ props: button3_props });
	binding_callbacks.push(() => bind(button3, "value", button3_value_binding));
	let if_block0 = /*recording*/ ctx[0] && create_if_block_1(ctx);
	let if_block1 = /*showSettings*/ ctx[3] && create_if_block(ctx);

	return {
		c() {
			main = element("main");
			div0 = element("div");
			create_component(looomcanvas.$$.fragment);
			t0 = space();
			div3 = element("div");
			nav = element("nav");
			create_component(button0.$$.fragment);
			t1 = space();
			create_component(button1.$$.fragment);
			t2 = space();
			create_component(button2.$$.fragment);
			t3 = space();
			create_component(button3.$$.fragment);
			t4 = space();
			if (if_block0) if_block0.c();
			t5 = space();
			div2 = element("div");

			div2.innerHTML = `<div><p class="svelte-gfhnbb"><a target="_blank" href="https://iorama.studio/" class="svelte-gfhnbb">Looom</a> web
          exporter and renderer by
          <a href="https://twitter.com/mattdesl" target="_blank" class="svelte-gfhnbb">@mattdesl</a>.</p></div>`;

			t10 = space();
			if (if_block1) if_block1.c();
			attr(div0, "class", "canvas-container svelte-gfhnbb");
			attr(nav, "class", "svelte-gfhnbb");
			attr(div2, "class", "info svelte-gfhnbb");
			attr(div3, "class", "content svelte-gfhnbb");
			attr(main, "class", "svelte-gfhnbb");
		},
		m(target, anchor) {
			insert(target, main, anchor);
			append(main, div0);
			mount_component(looomcanvas, div0, null);
			append(main, t0);
			append(main, div3);
			append(div3, nav);
			mount_component(button0, nav, null);
			append(nav, t1);
			mount_component(button1, nav, null);
			append(nav, t2);
			mount_component(button2, nav, null);
			append(nav, t3);
			mount_component(button3, nav, null);
			append(nav, t4);
			if (if_block0) if_block0.m(nav, null);
			append(div3, t5);
			append(div3, div2);
			append(main, t10);
			if (if_block1) if_block1.m(main, null);
			current = true;
		},
		p(ctx, dirty) {
			const looomcanvas_changes = {};
			if (dirty[0] & /*settings*/ 2) looomcanvas_changes.resamplePaths = /*settings*/ ctx[1].resamplePaths;
			if (dirty[0] & /*settings*/ 2) looomcanvas_changes.recenter = /*settings*/ ctx[1].recenter;
			if (dirty[0] & /*settings*/ 2) looomcanvas_changes.transparentBackground = /*settings*/ ctx[1].transparentBackground && !/*ignoreTransparency*/ ctx[10].includes(/*settings*/ ctx[1].format);
			if (dirty[0] & /*settings*/ 2) looomcanvas_changes.quantizeWithAlpha = /*settings*/ ctx[1].quantizeWithAlpha;
			if (dirty[0] & /*settings*/ 2) looomcanvas_changes.fps = /*settings*/ ctx[1].fps;
			if (dirty[0] & /*settings*/ 2) looomcanvas_changes.duration = /*settings*/ ctx[1].duration;
			if (dirty[0] & /*settings*/ 2) looomcanvas_changes.qualityPreset = /*settings*/ ctx[1].qualityPreset;
			if (dirty[0] & /*settings*/ 2) looomcanvas_changes.format = /*settings*/ ctx[1].format;
			if (dirty[0] & /*settings*/ 2) looomcanvas_changes.sizing = /*settings*/ ctx[1].sizing;
			if (dirty[0] & /*settings*/ 2) looomcanvas_changes.customWidth = /*settings*/ ctx[1].width;
			if (dirty[0] & /*settings*/ 2) looomcanvas_changes.customHeight = /*settings*/ ctx[1].height;
			if (dirty[0] & /*svg*/ 256) looomcanvas_changes.data = /*svg*/ ctx[8];

			if (!updating_running && dirty[0] & /*running*/ 4) {
				updating_running = true;
				looomcanvas_changes.running = /*running*/ ctx[2];
				add_flush_callback(() => updating_running = false);
			}

			if (!updating_recording && dirty[0] & /*recording*/ 1) {
				updating_recording = true;
				looomcanvas_changes.recording = /*recording*/ ctx[0];
				add_flush_callback(() => updating_recording = false);
			}

			looomcanvas.$set(looomcanvas_changes);
			const button0_changes = {};
			if (dirty[0] & /*foreground*/ 128) button0_changes.color = /*foreground*/ ctx[7];
			button0.$set(button0_changes);
			const button1_changes = {};
			if (dirty[0] & /*foreground*/ 128) button1_changes.color = /*foreground*/ ctx[7];
			if (dirty[0] & /*recording*/ 1) button1_changes.enabled = !/*recording*/ ctx[0];
			if (dirty[0] & /*showSettings*/ 8) button1_changes.svg = /*showSettings*/ ctx[3] ? "settings-open" : "settings";

			if (!updating_value && dirty[0] & /*showSettings*/ 8) {
				updating_value = true;
				button1_changes.value = /*showSettings*/ ctx[3];
				add_flush_callback(() => updating_value = false);
			}

			button1.$set(button1_changes);
			const button2_changes = {};
			if (dirty[0] & /*foreground*/ 128) button2_changes.color = /*foreground*/ ctx[7];
			if (dirty[0] & /*recording*/ 1) button2_changes.enabled = !/*recording*/ ctx[0];
			if (dirty[0] & /*running*/ 4) button2_changes.svg = /*running*/ ctx[2] ? "player-pause" : "player-play";

			if (!updating_value_1 && dirty[0] & /*running*/ 4) {
				updating_value_1 = true;
				button2_changes.value = /*running*/ ctx[2];
				add_flush_callback(() => updating_value_1 = false);
			}

			button2.$set(button2_changes);
			const button3_changes = {};
			if (dirty[0] & /*foreground*/ 128) button3_changes.color = /*foreground*/ ctx[7];

			if (dirty[0] & /*recording*/ 1) button3_changes.svg = /*recording*/ ctx[0]
			? "player-recording"
			: "player-record";

			if (!updating_value_2 && dirty[0] & /*recording*/ 1) {
				updating_value_2 = true;
				button3_changes.value = /*recording*/ ctx[0];
				add_flush_callback(() => updating_value_2 = false);
			}

			button3.$set(button3_changes);

			if (/*recording*/ ctx[0]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty[0] & /*recording*/ 1) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_1(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(nav, null);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if (/*showSettings*/ ctx[3]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[0] & /*showSettings*/ 8) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(main, null);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(looomcanvas.$$.fragment, local);
			transition_in(button0.$$.fragment, local);
			transition_in(button1.$$.fragment, local);
			transition_in(button2.$$.fragment, local);
			transition_in(button3.$$.fragment, local);
			transition_in(if_block0);
			transition_in(if_block1);
			current = true;
		},
		o(local) {
			transition_out(looomcanvas.$$.fragment, local);
			transition_out(button0.$$.fragment, local);
			transition_out(button1.$$.fragment, local);
			transition_out(button2.$$.fragment, local);
			transition_out(button3.$$.fragment, local);
			transition_out(if_block0);
			transition_out(if_block1);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(main);
			/*looomcanvas_binding*/ ctx[16](null);
			destroy_component(looomcanvas);
			destroy_component(button0);
			destroy_component(button1);
			destroy_component(button2);
			destroy_component(button3);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
		}
	};
}

const isTablet = false; // Cannot detect this reliably?
let initialBackground = "#FFD6BB";

async function readFile(file) {
	return new Promise((resolve, reject) => {
			const name = file.name;
			const reader = new FileReader();

			reader.onload = ({ target }) => {
				resolve(target.result);
			};

			reader.onerror = () => reject(new Error(`Error reading ${name}`));
			reader.readAsText(file);
		});
}

const click_handler = e => {
	e.stopPropagation();
};

function instance($$self, $$props, $$invalidate) {
	const ignoreTransparency = ["mp4", "webm"];
	const hasMP4 = isWebCodecsSupported();
	const hasWebM = isWebMSupported();
	const hasFile = isFrameSequenceSupported();
	let formats = [{ value: "gif", name: "GIF Animation" }];
	if (hasWebM) formats.push({ value: "webm", name: "WebM Video" });
	if (hasMP4) formats.push({ value: "mp4", name: "MP4 Video (H264)" });

	if (hasFile) formats.push({
		value: "sequence:png",
		name: "PNG File Sequence"
	});

	// formats.push({ value: "sequence:svg", name: "SVG File Sequence" });
	const hasAllFormats = hasMP4 && hasWebM;

	const initialFormat = formats[0].value;
	let settings = { format: initialFormat };
	let running = true;
	let recording = false;
	let showSettings = false;
	let progress = 0;
	let pass = 0;
	let totalPasses = 1;
	let foreground, background;
	let svg;
	let looom;
	dragDrop(document.body, files => loadSVGFile(files[0]));
	setBackground(initialBackground);

	onMount(() => {
		if (!svg) loadSplash();
	});

	function downloadJSON() {
		if (looom) {
			looom.downloadJSON();
		}
	}

	async function loadSplash() {
		$$invalidate(8, svg = splashSVG);
	} // svg = await (await fetch(testSplash)).text();

	async function loadSVGFile(file) {
		$$invalidate(8, svg = await readFile(file));
	}

	function setBackground(color, blending) {
		// console.log("New background", color);
		$$invalidate(7, foreground = bestForeground(color));

		if (svg === splashSVG) blending = false;

		background = blending
		? Color.blend(color, foreground, 0.1).hex
		: color;

		$$invalidate(7, foreground = Color.blend(foreground, color, 0.15).hex);
		document.body.style.backgroundColor = background;
		document.body.style.color = foreground;
		const corner = document.querySelector(".github-corner svg");

		if (corner) {
			corner.style.fill = Color.blend(foreground, color, 0).hex;
			corner.style.opacity = 1;
			corner.style.color = background;
		}
	}

	function bestForeground(color) {
		const a = Color.contrastRatio(color, "black");
		const b = Color.contrastRatio(color, "white");
		return a >= b ? "black" : "white";
	}

	function looomcanvas_binding($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			looom = $$value;
			$$invalidate(9, looom);
		});
	}

	function looomcanvas_running_binding(value) {
		running = value;
		$$invalidate(2, running);
	}

	function looomcanvas_recording_binding(value) {
		recording = value;
		$$invalidate(0, recording);
	}

	const recordProgress_handler = ({ detail }) => {
		$$invalidate(4, progress = detail.progress);
		$$invalidate(6, totalPasses = detail.totalPasses);
		$$invalidate(5, pass = detail.pass);
	};

	const load_handler = ({ detail: weave }) => {
		if (weave) {
			setBackground(weave.backgroundColor, true);
		} else setBackground(initialBackground, true);
	};

	const file_handler = ({ detail }) => loadSVGFile(detail);

	function button1_value_binding(value) {
		showSettings = value;
		($$invalidate(3, showSettings), $$invalidate(0, recording));
	}

	function button2_value_binding(value) {
		running = value;
		$$invalidate(2, running);
	}

	function button3_value_binding(value) {
		recording = value;
		$$invalidate(0, recording);
	}

	function settings_1_duration_binding(value) {
		settings.duration = value;
		$$invalidate(1, settings);
	}

	function settings_1_fps_binding(value) {
		settings.fps = value;
		$$invalidate(1, settings);
	}

	function settings_1_recenter_binding(value) {
		settings.recenter = value;
		$$invalidate(1, settings);
	}

	function settings_1_format_binding(value) {
		settings.format = value;
		$$invalidate(1, settings);
	}

	function settings_1_transparentBackground_binding(value) {
		settings.transparentBackground = value;
		$$invalidate(1, settings);
	}

	function settings_1_quantizeWithAlpha_binding(value) {
		settings.quantizeWithAlpha = value;
		$$invalidate(1, settings);
	}

	function settings_1_qualityPreset_binding(value) {
		settings.qualityPreset = value;
		$$invalidate(1, settings);
	}

	function settings_1_resamplePaths_binding(value) {
		settings.resamplePaths = value;
		$$invalidate(1, settings);
	}

	function settings_1_sizing_binding(value) {
		settings.sizing = value;
		$$invalidate(1, settings);
	}

	function settings_1_width_binding(value) {
		settings.width = value;
		$$invalidate(1, settings);
	}

	function settings_1_height_binding(value) {
		settings.height = value;
		$$invalidate(1, settings);
	}

	const click_handler_1 = e => {
		$$invalidate(3, showSettings = false);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty[0] & /*recording*/ 1) {
			$: {
				if (recording) $$invalidate(3, showSettings = false); else {
					$$invalidate(4, progress = $$invalidate(5, pass = 0));
					$$invalidate(6, totalPasses = 1);
				}
			}
		}
	};

	return [
		recording,
		settings,
		running,
		showSettings,
		progress,
		pass,
		totalPasses,
		foreground,
		svg,
		looom,
		ignoreTransparency,
		formats,
		hasAllFormats,
		downloadJSON,
		loadSVGFile,
		setBackground,
		looomcanvas_binding,
		looomcanvas_running_binding,
		looomcanvas_recording_binding,
		recordProgress_handler,
		load_handler,
		file_handler,
		button1_value_binding,
		button2_value_binding,
		button3_value_binding,
		settings_1_duration_binding,
		settings_1_fps_binding,
		settings_1_recenter_binding,
		settings_1_format_binding,
		settings_1_transparentBackground_binding,
		settings_1_quantizeWithAlpha_binding,
		settings_1_qualityPreset_binding,
		settings_1_resamplePaths_binding,
		settings_1_sizing_binding,
		settings_1_width_binding,
		settings_1_height_binding,
		click_handler_1
	];
}

class App extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {}, [-1, -1]);
	}
}

export default App;